module.exports = __webpack_public_path__ + "static/media/logo.ad51c5a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 224
// module chunks = 0